// import { CircularProgress, Box, Button } from '@mui/material';
// import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
// import { Grid, GridCellProps, GridColumn, GridSortChangeEvent, GridToolbar } from '@progress/kendo-react-grid';
// import { useEffect, useState } from 'react';
// import { post } from 'src/api/Api';
// import VendorApi from 'src/api/VendorApi';
// import useAuth from 'src/hooks/useAuth';
// import useSnackbar from 'src/hooks/useSnackbar';
// import useVendor from 'src/hooks/useVendor';
// import { defaultEditVendorModal, EditVendorModal } from 'src/types/EditVendorModal';
// import { User } from 'src/types/user';
// import { Vendor } from 'src/types/vendor';
// import DateCell from '../grid/DateCell';
// import { EditCommandCell } from '../grid/EditCommandCell';
// import LinkVendorDialog from './linkVendorDialog';
// import VendorEditForm from './vendorEditForm';

declare interface Props {}

const PimDataGrid: React.FC<React.PropsWithChildren<Props>> = () => {
  return <div>uncomment data grid</div>;

  // const { vendor } = useVendor();
  // const [sort, setSort] = useState<Array<SortDescriptor>>([{ field: 'fieldName', dir: 'asc' }]);
  // const [data, setData] = useState<User[]>([]);
  // const [openForm, setOpenForm] = useState(false);
  // const [openLinkUser, setOpenLinkUser] = useState(false);
  // const [editUser, setEditUser] = useState<EditVendorModal>({ ...defaultEditVendorModal });
  // const [linkUser, setLinkUser] = useState<User | null>(null);
  // const [isLoading, setIsLoading] = useState(false);
  // const { openSnackBar } = useSnackbar();
  // const { user } = useAuth();

  // const loadData = () => {
  //   setIsLoading(true);
  //   VendorApi.getUsersByVendorNumber(vendor?.numberString)
  //     .then((result) => {
  //       setData(result);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   loadData();
  // }, [vendor?.numberString]);

  // const enterEdit = (u: User) => {
  //   setOpenForm(true);

  //   let modalUser: EditVendorModal = {
  //     companyUserId: u.id,
  //     username: u.name,
  //     email: u.email,
  //     isActive: u.isActive,
  //     role: u.vendorPortalRole,
  //     newPassword: '',
  //     vendorName: vendor.name,
  //     vendorNumber: vendor.numberString,
  //   };

  //   setEditUser(modalUser);
  // };

  // const addNewUser = () => {
  //   setOpenForm(true);
  //   setEditUser({ ...defaultEditVendorModal, vendorName: vendor.name, vendorNumber: vendor.numberString });
  // };

  // const vendorEditSubmit = (modalValues: EditVendorModal) => {
  //   setIsLoading(true);
  //   post<User>('/UserAdmin/upsertUser', { ...modalValues, vendorName: vendor.name, vendorNumber: vendor.numberString })
  //     .then(() => {
  //       loadData();
  //       openSnackBar(`${modalValues.username} ${modalValues.companyUserId ? 'Updated' : 'Added'}`);
  //     })
  //     .catch((err) => {
  //       openSnackBar(`Failed to save user ${err}`, 'error');
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });

  //   setOpenForm(false);
  // };

  // const onVendorLinkClick = (u: User) => {
  //   setLinkUser(u);
  //   setOpenLinkUser(true);
  // };

  // const addNewLinkedVendorToUser = (newVendor: Vendor, u: User) => {
  //   setIsLoading(true);
  //   post<number>('/UserAdmin/linkUserToVendor', { vendorNumber: newVendor.numberString, companyUserId: u.id })
  //     .then(() => {
  //       loadData();
  //       openSnackBar(`User Linked to ${newVendor.name}`);
  //     })
  //     .catch((err) => {
  //       openSnackBar(`Failed to link user ${err}`, 'error');
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });

  //   setOpenLinkUser(false);
  // };

  // const MyUsernameCell = (props: GridCellProps) => {
  //   const u = props.dataItem as User;
  //   console.log(data, 'dataitem');
  //   return (
  //     <td className="hover-cell-button">
  //       <span>{u.name}</span> <MyEditCommandCell />
  //     </td>
  //   );
  // };
  // const MyEditCommandCell = (props: GridCellProps | any) => <EditCommandCell {...props} enterEdit={enterEdit} />;
  // const MyLinkUserCommandCell = (props: GridCellProps | any) => <LinkUserCommandCell {...props} onVendorLinkClick={onVendorLinkClick} />;
  // const MyVendorCell = (props: GridCellProps) => <VendorCell {...props} />;

  // const LinkUserCommandCell = (props: GridCellProps | any) => {
  //   return (
  //     <td>
  //       <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary" onClick={() => props.onVendorLinkClick(props.dataItem)}>
  //         Link User
  //       </button>
  //     </td>
  //   );
  // };

  // const VendorCell = (props: GridCellProps) => {
  //   const u = props.dataItem as User;
  //   const titleText = u.vendors.map((v: Vendor) => v.name + ' - ' + v.numberString).join('\r');
  //   return <td title={titleText}>{u.vendors.length}</td>;
  // };

  // const cancelLinkVendorDialog = () => {
  //   setOpenLinkUser(false);
  //   loadData();
  // };

  // return (
  //   <>
  //     {/* <VendorEditForm cancelEdit={() => setOpenForm(false)} onSubmit={vendorEditSubmit} isOpen={openForm} user={editUser} /> */}
  //     {/* <LinkVendorDialog isOpen={openLinkUser} cancel={cancelLinkVendorDialog} onSubmit={addNewLinkedVendorToUser} user={linkUser} /> */}

  //     <Button sx={{ mb: 3 }} variant="contained" onClick={addNewUser}>
  //       Add new
  //     </Button>

  //     <Box
  //       sx={{
  //         overflowX: 'auto',
  //         position: 'relative',
  //       }}
  //     >
  //       {isLoading && (
  //         <CircularProgress sx={{ position: 'absolute', mt: 1, top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 9 }} size="1.5rem"></CircularProgress>
  //       )}

  //       <Grid
  //         data={orderBy(data, sort)}
  //         total={data.length}
  //         sortable={true}
  //         sort={sort}
  //         id="userAdminGrid"
  //         key={vendor.numberString}
  //         onSortChange={(e: GridSortChangeEvent) => {
  //           setSort(e.sort);
  //         }}
  //         resizable={false}
  //         style={{ minWidth: '900px' }}
  //       >
  //         {/* <GridColumn field="name" title="Username" /> */}
  //         <GridColumn cell={MyUsernameCell} width="250" />
  //         <GridColumn field="email" title="Email" />
  //         <GridColumn field="vendorPortalRole" title="role" />
  //         <GridColumn field="isActive" title="IsActive" />
  //         <GridColumn field="activatedDate" title="Activated Date" cell={DateCell} />
  //         {/* <GridColumn field="lastLogin" title="Last Login" cell={DateCell} width={80} /> */}
  //         <GridColumn field="passwordUpdateDate" title="Last Pwd Update" cell={DateCell} />
  //         {user?.vendors.length > 1 && <GridColumn field="vendors" title="Linked Vendors" cell={MyVendorCell} />}
  //         {/* <GridColumn cell={MyEditCommandCell} title="Edit" /> */}
  //         {user?.vendors.length > 1 && <GridColumn cell={MyLinkUserCommandCell} title="Link User" />}
  //       </Grid>
  //     </Box>
  //   </>
  // );
};

export default PimDataGrid;
